import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarView from "./sidebar-view";
import {
  FaMap,
  FaCreditCard,
  FaUsersCog,
  FaUserAstronaut,
  FaCalendarCheck
} from "react-icons/fa";
import { FiClock, FiHome, FiCheckCircle } from "react-icons/fi";
import { toggleSidebarCollapse } from "../layout/layout-actions";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredLink: null,
      userAreaHovered: false,
      showUserMenu: false
    };
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.anyClick, false);
  }

  mouseEnterSidebarLink = sidebarItem =>
    this.setState({ hoveredLink: sidebarItem.title });
  mouseLeaveSidebarLink = () => this.setState({ hoveredLink: null });
  mouseEnterCurrentUser = () => this.setState({ userAreaHovered: true });
  mouseLeaveCurrentUser = () => this.setState({ userAreaHovered: false });
  toggleUserMenu = () =>
    this.setState({ showUserMenu: !this.state.showUserMenu });

  render() {
    const categories = [
      {
        name: "Bookings",
        links: [
          // {
          //   title: "Overview",
          //   to: "/",
          //   icon: FiHome
          // },
          {
            title: "Scheduled",
            hoverTitle: "Scheduled Bookings",
            to: "/scheduled-bookings",
            icon: FiClock
          },
          {
            title: "Completed",
            hoverTitle: "Completed Bookings",
            to: "/past-bookings",
            icon: FaCalendarCheck
          }
        ]
      },
      {
        name: "Drivers",
        links: [
          {
            title: "Available",
            hoverTitle: "Available Drivers",
            to: "/available-drivers",
            icon: FiCheckCircle
          },
          {
            title: "Map",
            hoverTitle: "Drivers Map",
            to: "/map",
            icon: FaMap
          },
          {
            title: "Manage drivers",
            hoverTitle: "Manage Drivers",
            to: "/manage-drivers",
            icon: FaUserAstronaut,
            adminOnly: true
          }
        ]
      },
      {
        name: "Settings",
        links: [
          {
            title: "Users & Permissions",
            to: "/users-and-permissions",
            icon: FaUsersCog,
            hide: !this.props.auth.business
          },
          {
            title: "Payment",
            to: "/payment",
            icon: FaCreditCard,
            permissionNeeded: "billing"
          }
        ]
      }
    ];

    return (
      <SidebarView
        {...this.props}
        categories={categories}
        mouseEnterSidebarLink={this.mouseEnterSidebarLink}
        mouseLeaveSidebarLink={this.mouseLeaveSidebarLink}
        hoveredLink={this.state.hoveredLink}
        mouseEnterCurrentUser={this.mouseEnterCurrentUser}
        mouseLeaveCurrentUser={this.mouseLeaveCurrentUser}
        userAreaHovered={this.state.userAreaHovered}
        toggleUserMenu={this.toggleUserMenu}
        showUserMenu={this.state.showUserMenu}
        setRef={this.setRef}
        setCurrentUserContainerRef={this.setCurrentUserContainerRef}
      />
    );
  }

  anyClick = e => {
    if (this.userMenuNode.contains(e.target)) return;

    if (this.currentUserContainerNode.contains(e.target)) {
      this.toggleUserMenu();
      return;
    }

    this.setState({ showUserMenu: false });
  };

  setRef = ref => (this.userMenuNode = ref);
  setCurrentUserContainerRef = ref => (this.currentUserContainerNode = ref);

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.anyClick, false);
  }
}

const mapStateToProps = state => ({
  layout: state.layout,
  auth: state.auth,
  businessAccounts: state.businessAccounts
});

const mapDispatchToProps = {
  toggleSidebarCollapse: toggleSidebarCollapse
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js